import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { errMsg } from "@/lib/api";
import AuthShell from "./AuthShell";
import { t } from "@/i18n";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title={t("forgotPassword.mot_de_passe_oublie")}
      subtitle={t("forgotPassword.recevez_un_lien_securise_pour_choisir_un_n")}
      footer={<Link to="/login" className="font-semibold text-foreground hover:underline" data-testid="back-to-login-link">{t("forgotPassword.retour_a_la_connexion")}</Link>}
    >
      {sent ? (
        <div className="rounded-xl border bg-emerald-500/10 p-5 text-sm" data-testid="forgot-success">
          <MailCheck className="mb-2 h-5 w-5 text-emerald-500" />
          {t("forgotPassword.si_un_compte_existe_pour")} <strong>{email}</strong>{t("forgotPassword.un_e_mail_contenant_le_lien_de_reinitialis")}
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div className="space-y-2">
            <Label htmlFor="email">{t("common.email")}</Label>
            <Input id="email" type="email" required data-testid="forgot-email-input" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="vous@restaurant.fr" />
          </div>
          {error && <p className="text-sm text-rose-500" data-testid="forgot-error">{error}</p>}
          <Button type="submit" className="w-full" disabled={loading} data-testid="forgot-submit-btn">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}{t("forgotPassword.envoyer_le_lien")}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
